import React, {Fragment} from "react";
import {StringUtility} from "../common/StringUtility";
import {Constants} from "../common/Constants";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {DateUtility} from "../common/DateUtility";
import _ from "lodash";

export let InvoiceSyncStatusBreakdown = function (props) {
    let paymentSyncStatusDisplay = []
    let sortedSyncStatusDataKeys = Object.keys(props.syncStatusData.payments_by_deposit || []).sort();
    for (let i = 0; i < sortedSyncStatusDataKeys.length; i++) {
        let paymentGroupData = props.syncStatusData.payments_by_deposit[sortedSyncStatusDataKeys[i]];
        let paymentLines = [];

        let payoutAndDepositMissing = !paymentGroupData.ext_qbo_deposit_id && !paymentGroupData.ext_stripe_payout_id;

        for (let k = 0; k < paymentGroupData.payments.length; k++) {
            let payment = paymentGroupData.payments[k]

            let paidFromDisplay = null;
            if (
                payment.payment_origin_external_platform_name === Constants.externalPlatformNames.stripe ||
                payment.payment_origin_external_platform_name === Constants.externalPlatformNames.qbo
            ) {
                paidFromDisplay = (
                    <div
                        className="payment-paid-from"
                    >{`Paid from ${payment.payment_origin_external_platform_name}`}</div>
                )
            }

            let stripePaymentDisplay = null;
            let paymentSynced = true;
            if (payment.payment_origin_external_platform_name === Constants.externalPlatformNames.stripe) {
                if (payment.ext_stripe_payment_url) {
                    stripePaymentDisplay = (
                        <PaymentLinkDisplay
                            platform={Constants.externalPlatformNames.stripe}
                            label="Stripe payment"
                            amount={payment.stripe_amount}
                            url={payment.ext_stripe_payment_url}
                        />
                    )
                } else {
                    paymentSynced = false;
                    stripePaymentDisplay = (
                        <MissingPaymentDisplay
                            platform={Constants.externalPlatformNames.stripe}
                            label="Stripe payment"
                        />
                    )
                }
            } else {
                if (payment.ext_stripe_credit_note_url) {
                    stripePaymentDisplay = (
                        <PaymentLinkDisplay
                            platform={Constants.externalPlatformNames.stripe}
                            label="Stripe credit note"
                            amount={payment.stripe_amount}
                            url={payment.ext_stripe_credit_note_url}
                        />
                    )
                } else {
                    paymentSynced = false;
                    stripePaymentDisplay = (
                        <MissingPaymentDisplay
                            platform={Constants.externalPlatformNames.stripe}
                            label="Stripe credit note"
                        />
                    )
                }
            }

            let qboPaymentDisplay = null;
            if (payment.ext_qbo_payment_url) {
                qboPaymentDisplay = (
                    <PaymentLinkDisplay
                        platform={Constants.externalPlatformNames.qbo}
                        label="QBO payment"
                        amount={payment.qbo_amount}
                        url={payment.ext_qbo_payment_url}
                    />
                )
            } else {
                paymentSynced = false;
                qboPaymentDisplay = (
                    <MissingPaymentDisplay
                        platform={Constants.externalPlatformNames.qbo}
                        label="QBO payment"
                    />
                )
            }

            let paymentSyncStatusIconSrc = "/static/images/arrow-forward-textcolor.svg";
            let paymentSyncStatusIconClasses = "link-icon "
            if (paymentSynced) {
                paymentSyncStatusIconClasses += "synced-payment"
            } else {
                paymentSyncStatusIconClasses += "unsynced-payment"
                paymentSyncStatusIconSrc = "/static/images/link-off-red.svg";
            }
            let originPaymentDisplay = stripePaymentDisplay;
            let syncDestinationPaymentDisplay = qboPaymentDisplay;
            if (payment.payment_origin_external_platform_name === Constants.externalPlatformNames.qbo) {
                originPaymentDisplay = qboPaymentDisplay;
                syncDestinationPaymentDisplay = stripePaymentDisplay;
            }
            let btSyncStatusIndicatorSrc = "/static/images/link-textcolor.svg";
            let btSyncStatusIndicatorClasses = "link-icon floating-bt-sync-status-icon ";
            if (
                payment.payment_origin_external_platform_name === Constants.externalPlatformNames.stripe &&
                !payment.stripe_bt_synced
            ) {
                if (payoutAndDepositMissing) {
                    btSyncStatusIndicatorSrc = "/static/images/link-off-textcolor.svg"
                    btSyncStatusIndicatorClasses += "payout-and-deposit-missing"
                } else {
                    btSyncStatusIndicatorClasses += "payout-present-but-bt-not-synced"
                    btSyncStatusIndicatorSrc = "/static/images/link-off-red.svg"
                }
            } else {
                btSyncStatusIndicatorClasses += 'bt-synced'
            }

            paymentLines.push((
                <div
                    key={`payment-line-${k}`}
                    className="payment-line"
                >
                    <div className="payment-line-connector-extender"/>
                    <div className="payment-line-content">
                        {paidFromDisplay}
                        {originPaymentDisplay}
                        <img
                            src={paymentSyncStatusIconSrc}
                            className={paymentSyncStatusIconClasses}
                        />
                        {syncDestinationPaymentDisplay}
                        <ConditionalRenderer
                            if={payment.payment_origin_external_platform_name === Constants.externalPlatformNames.stripe}
                            renderer={() => (
                                <img
                                    src={btSyncStatusIndicatorSrc}
                                    className={btSyncStatusIndicatorClasses}
                                />
                            )}
                        />
                    </div>
                </div>
            ))
        }

        let stripeDepositDisplay = null;
        let qboDepositDisplay = null;
        let linkIcon = null;
        let qboDepositPresent = true;

        if (paymentGroupData.ext_qbo_deposit_url) {
            qboDepositDisplay = (
                <DepositLinkDisplay
                    platform={Constants.externalPlatformNames.qbo}
                    label="QBO deposit"
                    url={paymentGroupData.ext_qbo_deposit_url}
                    amount={paymentGroupData.qbo_deposit_amount}
                />
            )
        } else {
            qboDepositPresent = false;
            qboDepositDisplay = (
                <MissingDepositDisplay
                    platform={Constants.externalPlatformNames.qbo}
                    label="QBO deposit"
                    subLabel="Not synced"
                />
            )
        }

        if (paymentGroupData.ext_qbo_deposit_id && !paymentGroupData.ext_stripe_payout_id) {
            // payment and its deposit originated in QBO, so there won't be Stripe payout info
        } else {
            let payoutSyncStatusIconSrc = "/static/images/arrow-forward-textcolor.svg";
            let payoutSyncStatusIconClasses = "link-icon "
            if (qboDepositPresent) {
                payoutSyncStatusIconClasses += "synced-payout"
            } else {
                payoutSyncStatusIconClasses += "unsynced-payout"
                payoutSyncStatusIconSrc = "/static/images/link-off-red.svg";
            }
            linkIcon = (
                <img
                    src={payoutSyncStatusIconSrc}
                    className={payoutSyncStatusIconClasses}
                />
            )
            if (paymentGroupData.deposit_origin_external_platform_name === Constants.externalPlatformNames.stripe) {
                if (paymentGroupData.ext_stripe_payout_url) {
                    stripeDepositDisplay = (
                        <DepositLinkDisplay
                            platform={Constants.externalPlatformNames.stripe}
                            label="Stripe payout"
                            url={paymentGroupData.ext_stripe_payout_url}
                            amount={paymentGroupData.stripe_payout_amount}
                        />
                    )
                } else {
                    stripeDepositDisplay = (
                        <MissingDepositDisplay
                            platform={Constants.externalPlatformNames.stripe}
                            label="Stripe payout"
                            subLabel={payoutAndDepositMissing ? "Not found - may not have happened yet" : "Not synced"}
                        />
                    )
                }
            }
        }

        let depositDisplay = null

        if (paymentGroupData.deposit_origin_external_platform_name === Constants.externalPlatformNames.stripe) {
            depositDisplay = (
                <div className="payment-deposit">
                    {stripeDepositDisplay}
                    <ConditionalRenderer if={!payoutAndDepositMissing} renderer={() => (
                        <Fragment>
                            {linkIcon}
                            {qboDepositDisplay}
                        </Fragment>
                    )}/>
                </div>
            )
        }

        paymentSyncStatusDisplay.push(
            <div
                key={`payment-group-line-${i}`}
                className="payment-group"
            >
                <div className="payment-group-content">
                    <div className="payment-lines">
                        <div className="payment-lines-content">
                            {paymentLines}
                        </div>
                    </div>
                    {depositDisplay}
                </div>
            </div>
        )
    }

    let stripeInvoiceDateDisplay = props.stripeInvoice ?
        `(${DateUtility.stripeTimestampToDateDisplay(props.stripeInvoice.created)})` :
        null;
    let qboInvoiceDateDisplay = `(${DateUtility.qboTxnDateToDateDisplay(props.qboInvoice.TxnDate)})`;

    let stripeInvoiceDisplay = null;
    if (props.stripeInvoice && props.stripeInvoice.status !== 'void') {
        stripeInvoiceDisplay = (
            <InvoiceLinkDisplay
                label={`Stripe invoice ${props.stripeInvoice.number}`}
                warningLabel={props.stripeInvoice.status === 'draft' ? '(DRAFT)' : null}
                sublabel={stripeInvoiceDateDisplay}
                wrapperClass="stripe-invoice-link"
                paid={props.syncStatusData.stripe_invoice_amount_paid}
                total={props.syncStatusData.stripe_invoice_total}
                url={props.syncStatusData.ext_stripe_invoice_url}
                footerRenderer={() => {
                    let stripePaymentMethods = props.stripeInvoice?.payment_settings?.payment_method_types || [];
                    let payableByDisplay = 'Payable by default methods defined in the Stripe admin';
                    if (stripePaymentMethods.length > 0) {
                        let supportedPaymentMethods = [];
                        for (let i = 0; i < stripePaymentMethods.length; i++) {
                            let paymentMethodKey = stripePaymentMethods[i];
                            let supportedStripePaymentTypeKeys = _.keys(props.supportedStripePaymentTypes)
                            for (let k = 0; k < supportedStripePaymentTypeKeys.length; k++) {
                                let stripePaymentTypeKey = supportedStripePaymentTypeKeys[k]
                                if (stripePaymentTypeKey === paymentMethodKey) {
                                    supportedPaymentMethods.push(
                                        props.supportedStripePaymentTypes[stripePaymentTypeKey]
                                    )
                                    break;
                                }
                            }
                        }
                        let paymentOptionsString = _.uniq(supportedPaymentMethods).join(', ')
                        payableByDisplay = `Payable by ${paymentOptionsString}`;
                    }
                    return (
                        <div className="external-link-box-footer">
                            {payableByDisplay}
                        </div>
                    )
                }}
                paymentOptions={props.stripeInvoice.payment_settings?.payment_method_types}
            />
        )
    } else {
        let stripeInvoiceStatus = 'Stripe invoice deleted.'
        let effectClass = 'deleted'
        if (props.stripeInvoice && props.stripeInvoice.status === 'void') {
            stripeInvoiceStatus = 'Stripe invoice voided.'
            effectClass = 'voided'
        }
        stripeInvoiceDisplay = (
            <div className="external-link-box invoice-sync-status-for-platform stripe-invoice-link">
                <div className="external-link-box-content">
                    <div className="external-link-box-header">
                        <div className="external-link-box-header-content">
                            <div className="external-link-box-header-text">
                                <div className={`external-link-box-header-text-label ${effectClass}`}>
                                    {stripeInvoiceStatus}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`external-link-box-body ${effectClass}`}>
                        {`There may have been an error during cancellation. Canceling this invoice again should complete the process.`}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="invoice-sync-status-breakdown">
            <div className="invoice-line">
                <div className="invoice-line-content">
                    {stripeInvoiceDisplay}
                    <img
                        src="/static/images/link-textcolor.svg"
                        className="link-icon"
                    />
                    <InvoiceLinkDisplay
                        label={`QBO invoice ${props.qboInvoice.DocNumber}`}
                        sublabel={qboInvoiceDateDisplay}
                        wrapperClass="qbo-invoice-link"
                        paid={props.syncStatusData.qbo_invoice_amount_paid}
                        total={props.syncStatusData.qbo_invoice_total}
                        url={props.syncStatusData.ext_qbo_invoice_url}
                    />
                </div>
            </div>
            {paymentSyncStatusDisplay}
        </div>
    )
}

let InvoiceLinkDisplay = function (props) {
    let paid = StringUtility.stringNumberToDisplayCurrency('' + props.paid)
    let total = StringUtility.stringNumberToDisplayCurrency('' + props.total)
    let paymentStatusDisplay = `${paid} of ${total} paid.`;
    return (
        <a
            className={`external-link-box with-link invoice-sync-status-for-platform ${props.wrapperClass}`}
            target="_blank"
            href={props.url}
        >
            <div className="external-link-box-content">
                <div className="external-link-box-header">
                    <div className="external-link-box-header-content">
                        <div className="external-link-box-header-text">
                            <div className="external-link-box-header-text-label">{props.label}</div>
                            <ConditionalRenderer if={props.warningLabel} renderer={() => (
                                <div className="external-link-box-header-text-warning-label">{props.warningLabel}</div>
                            )}/>
                            <ConditionalRenderer if={props.sublabel} renderer={() => (
                                <div className="external-link-box-header-text-sublabel">{props.sublabel}</div>
                            )}/>
                        </div>
                        <img
                            className="external-link-icon external-link-box-header-icon"
                            src="/static/images/open-external-link-textcolor.svg"
                        />
                    </div>
                </div>
                <div className="external-link-box-body">
                    {paymentStatusDisplay}
                </div>
                <ConditionalRenderer if={props.footerRenderer} renderer={props.footerRenderer}/>
            </div>
        </a>
    )
}

let PaymentLinkDisplay = function (props) {
    return (
        <a
            className={`external-link-box with-link platform-payment ${props.platform.toLowerCase()}`}
            target="_blank"
            href={props.url}
        >
            <div className="external-link-box-content">
                <div className="external-link-box-header">
                    <div className="external-link-box-header-content">
                        <div className="external-link-box-header-text">
                            {props.label}
                        </div>
                        <img
                            className="external-link-icon external-link-box-header-icon"
                            src="/static/images/open-external-link-textcolor.svg"
                        />
                    </div>
                </div>
                <div className="external-link-box-body">
                    {`${StringUtility.stringNumberToDisplayCurrency(props.amount)}`}
                </div>
            </div>
        </a>
    )
}

let MissingPaymentDisplay = function (props) {
    return (
        <div
            className={`external-link-box disabled platform-payment missing-platform-payment ${props.platform.toLowerCase()}`}>
            <div className="external-link-box-content">
                <div className="external-link-box-header">
                    <div className="external-link-box-header-content">
                        <div className="external-link-box-header-text">
                            {props.label}
                        </div>
                    </div>
                </div>
                <div className="external-link-box-body">
                    Not synced
                </div>
            </div>
        </div>
    )
}

let DepositLinkDisplay = function (props) {
    return (
        <a
            className={`external-link-box with-link platform-deposit ${props.platform.toLowerCase()}`}
            target="_blank"
            href={props.url}
        >
            <div className="external-link-box-content">
                <div className="external-link-box-header">
                    <div className="external-link-box-header-content">
                        <div className="external-link-box-header-text">
                            {props.label}
                        </div>
                        <img
                            className="external-link-icon external-link-box-header-icon"
                            src="/static/images/open-external-link-textcolor.svg"
                        />
                    </div>
                </div>
                <div className="external-link-box-body">
                    {`${StringUtility.stringNumberToDisplayCurrency(props.amount)}`}
                </div>
            </div>
        </a>
    )
}

let MissingDepositDisplay = function (props) {
    return (
        <div
            className={`external-link-box disabled platform-deposit missing-platform-deposit ${props.platform.toLowerCase()}`}>
            <div className="external-link-box-content">
                <div className="external-link-box-header">
                    <div className="external-link-box-header-content">
                        <div className="external-link-box-header-text">
                            {props.label}
                        </div>
                    </div>
                </div>
                <div className="external-link-box-body">
                    {props.subLabel}
                </div>
            </div>
        </div>
    )
}
